import { tokens } from './chakra';
function deepMerge(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (typeof target === 'object' && typeof source === 'object') {
        for(const key in source){
            if (typeof source[key] === 'object') {
                if (!target[key]) Object.assign(target, {
                    [key]: {}
                });
                deepMerge(target[key], source[key]);
            } else {
                if (!target[key]) Object.assign(target, {
                    [key]: source[key]
                });
            }
        }
    }
    return deepMerge(target, ...sources);
}
export function createChakraTokens(additionalTokens = {}) {
    return deepMerge(tokens, additionalTokens);
}

//# sourceMappingURL=utils.js.map